module.exports = __webpack_public_path__ + "static/media/prx_03.0a65192c.png";